import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ISubmission, IAssignment } from '@/components/interfaces';
import { teacher_submission_path } from '@/modules/routes';
import { IStudent } from '../../types';
import useGradesTableStore from '../../store/useGradesTableStore';
import StatusIndicator from './StatusIndicator';
import styles from '../styles.module.scss';

interface StudentGradeCellProps {
  assignment: IAssignment;
  lastCell?: boolean;
  student: IStudent;
  submission: ISubmission;
}

const StudentGradeCell = ({ assignment, lastCell = false, student, submission }: StudentGradeCellProps) => {
  const allAssignmentsAssigneeModels = useGradesTableStore(state => state.assignmentsAssigneeModels);
  const navigationParams = useGradesTableStore(state => state.navigationParams());

  const assignmentsAssigneeModels = useMemo(() => (
    allAssignmentsAssigneeModels.filter((aam) => {
      if (aam.assignment_id !== assignment.id) return false;
      if (aam.model_type === 'Student') return aam.model_id === student.id;

      return true; // classroom assignments are assigned to everyone
    })
  ), [assignment.id, student.id, allAssignmentsAssigneeModels]);

  const studentGrade = () => {
    if (submission) {
      return (
        <a
          className="tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center"
          href={teacher_submission_path(submission.id, { params: navigationParams })}
        >
          {submission?.total_score_override ?? submission?.total_score ?? '-'}
        </a>
      );
    }

    return <>-</>;
  };

  const isAssigned = assignmentsAssigneeModels.length > 0;

  return (
    <td
      key={`${student.id}-${assignment.id}`}
      className={clsx(styles.studentGradeCell, 'tw-transition-colors hover:tw-bg-tci-purple/15', {
        [styles.lastCell]: lastCell,
        'tw-bg-grey': !isAssigned,
      })}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-relative tw-h-full">
        {isAssigned && (
          <>{studentGrade()}</>
        )}
        <StatusIndicator
          assignment={assignment}
          isAssigned={isAssigned}
          submission={submission}
        />
      </div>
    </td>
  );
};

export default StudentGradeCell;
